import styles from "./index.module.scss";
import { useEffect, useRef } from "react";
import clsx from "clsx";
import { useCommonStore } from "@/stores";
import { loadScript } from "@/utils";

type FtLoadingProps = {
  title: string;
};

const FtLoading = (props: FtLoadingProps) => {
  const { title } = props;

  const loadingEleRef = useRef<HTMLDivElement>(null);
  const isMobile = useCommonStore((state) => state.isMobile);
  const instanceRef = useRef<any>(null);

  useEffect(() => {
    (async () => {
      if (!window.lottie) {
        await loadScript(
          "https://cdn.jsdelivr.net/npm/lottie-web@5.12.2/build/player/lottie.min.js"
        );
      }
      instanceRef.current = window.lottie.loadAnimation({
        container: loadingEleRef.current!,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: process.env.PUBLIC_URL + "/lotties/loading/animation.json",
        assetsPath: process.env.PUBLIC_URL + "/lotties/loading/images/",
      });
    })();

    return () => {
      instanceRef.current?.destroy?.();
    };
  }, []);

  return (
    <div className={styles["root"]}>
      <div ref={loadingEleRef} className={styles["loading"]}></div>

      <p className={clsx(styles["text"], !isMobile && "single_row_ellipsis")}>
        {title}
      </p>
    </div>
  );
};

export default FtLoading;
